module.exports = __webpack_public_path__ + "img/entertainment-banner.9877c195.jpg";